import React from 'react';
import s from '../OnboardingPage.module.scss';
import CreateIcon from '@material-ui/icons/Create';

export function ThirdCustomizationStep({ classNames, postLater, setUserName, userName, toAbsoluteUrl, guestAvatar, setUserImageChanged, userImageChanged, firstPostText, setFirstPostText, fakePostDefaultPicture, setPostImageChanged, postImageChanged, setPostLater }) {
    return (<><div className="pb-6 pb-lg-13 text-center text-md-left">
        <div className={classNames([s.stepHeader, s.fontWeight600, s.blackFont])}>Publish your first post in your community</div>
    </div>
        <div style={{
            marginBottom: '2.3rem'
        }}>
            <div style={{
                marginBottom: '0.3rem'
            }} className={classNames([s.mediumTextSize, s.fontWeight600, s.blackFont])}>Your username</div>
            <input style={{
                width: '616px',
                height: '64px'
            }} disabled={postLater} onChange={e => setUserName(e.target.value)} type="text" className="form-control form-control-solid h-auto p-6 border-0 rounded-lg font-size-h4" name="firstname" placeholder="Type your username" defaultValue={userName} />
        </div>
        <div style={{
            marginBottom: '0.3rem'
        }} className={classNames([s.mediumTextSize, s.fontWeight600, s.blackFont])}>Your profile picture</div>
        <div style={{
            marginBottom: '1.4rem'
        }} className="image-input image-input-outline image-input-circle" id="user-image-upload">
            <div className="image-input-wrapper" style={{
                height: '80px',
                width: '80px',
                backgroundImage: `url(${toAbsoluteUrl(guestAvatar)})`
            }}></div>
            <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" style={{
                top: '0',
                right: '0'
            }} data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
                <i className="fa fa-pen icon-sm text-muted"> <CreateIcon style={{
                    fontSize: '1rem'
                }} /></i>
                <input onChange={() => setUserImageChanged(userImageChanged + 1)} type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" />
            </label>
        </div>
        <div style={{
            marginBottom: '2.4rem',
            opacity: postLater ? '0.7' : '1'
        }}>
            <div style={{
                marginBottom: '0.3rem'
            }} className={classNames([s.mediumTextSize, s.fontWeight600, s.blackFont])}>Your post</div>
            <textarea maxLength="206" style={{
                width: '616px'
            }} disabled={postLater} rows="3" defaultValue={firstPostText} onChange={e => setFirstPostText(e.target.value)} type="text" className="form-control form-control-solid h-auto p-5 border-0 rounded-lg font-size-h4" name="firstname" />
        </div>
        <div style={{
            marginBottom: '0.3rem',
            opacity: postLater ? '0.7' : '1'
        }} className={classNames([s.mediumTextSize, s.fontWeight600, s.blackFont])}>Add an image</div>
        <div style={{
            opacity: postLater ? '0.7' : '1'
        }} className="image-input image-input-outline image-input-outline" id="post-image-upload">
            <div className="image-input-wrapper" style={{
                boxShadow: '0 0rem 1.5rem 0.5rem rgb(0 0 0 / 8%)',
                backgroundImage: `url(${toAbsoluteUrl(fakePostDefaultPicture)})`
            }}></div>
            <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" style={{
                top: '0',
                right: '0'
            }} data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
                <i className="fa fa-pen icon-sm text-muted"> <CreateIcon style={{
                    fontSize: '1rem'
                }} /></i>
                <input disabled={postLater} onChange={() => setPostImageChanged(postImageChanged + 1)} type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" />
            </label>
        </div>
        <label className="my-10 checkbox checkbox-dark d-block" style={{
            fontWeight: 500
        }}>
            <input onChange={e => setPostLater(e.target.checked)} type="checkbox" name="Checkboxes1" />
            <span style={{
                width: '24px',
                height: '24px'
            }}></span>
            <div className={classNames([s.mediumTextSize])} style={{
                marginLeft: '0.615rem'
            }}>
                I prefer to post later
            </div>
        </label></>);
}
